import * as moment from "moment";

export class BatchModel {
  id: any;
  umlId: any = null;
  name: string = '';
  startDate:any;
  endDate: any;
  subscription: string;
  schedule: string;
  batchPicture: string;
  batchTimings: any;
   constructor(public obj: any){
    let serverTime = localStorage.getItem('serverTime');
    let current_time = moment.unix(Number(serverTime)).format("YYYY-MM-DD HH:mm:ss");

    this.id = obj?.id || 1 ,
    this.name = obj?.name;
    this.startDate = obj?.startDate?  moment.unix( obj.startDate).format() : new Date(current_time);
    this.endDate = obj?.endDate?  moment.unix( obj.endDate).format() : new Date(current_time);
    this.subscription = obj?.subscription || 'FREE';
    this.schedule = obj?.schedule || '';  //pdf
    this.batchPicture = obj?.batchPicture;
    this.batchTimings = obj?.batchTimings
  }

}


